import { atom } from "jotai";

const headerStateAtom = atom<boolean>(false)

export default headerStateAtom;